import { cva } from '@/styled-system/css';

export const cardRootRecipe = cva({
  base: {
    position: 'relative',
    display: 'block',
    padding: 'Card.Root.padding',
    borderRadius: 'Card.Root',
    transition: {
      _motionReduce: 'none',
      _motionSafe:
        'box-shadow 0.2s ease-in, background-color 0.2s ease-in, border-color 0.2s ease-in',
    },

    _focusVisible: {
      boxShadow: 'focus',
    },
  },
  variants: {
    outlined: {
      true: {
        borderWidth: 'Card.Root',
        borderStyle: 'solid',
        borderColor: { base: 'Card.Root.neutral.border' },
      },
      false: {},
    },

    disabled: {
      true: {},
      false: {},
    },

    elevated: {
      true: {},
      false: {},
    },

    interactive: {
      true: {},
      false: {},
    },

    tone: {
      neutral: {
        backgroundColor: { base: 'Card.Root.neutral.bg' },
      },
      soft: {
        backgroundColor: { base: 'Card.Root.soft.bg' },
      },
    },
  },
  compoundVariants: [
    {
      outlined: true,
      tone: 'soft',
      css: {
        borderColor: { base: 'Card.Root.soft.border' },
      },
    },
    {
      elevated: true,
      interactive: false,
      tone: 'neutral',
      css: {
        boxShadow: 'Card.Root.elevated.default',
        backgroundColor: {
          base: 'Card.Root.interactive.neutral.elevated.bg.default',
        },
      },
    },
    {
      interactive: true,
      disabled: false,
      css: {
        cursor: 'pointer',
      },
    },
    {
      interactive: true,
      disabled: false,
      tone: 'neutral',
      css: {
        backgroundColor: {
          base: 'Card.Root.interactive.neutral.bg.default',
          _hover: 'Card.Root.interactive.neutral.bg.hover',
          _active: 'Card.Root.interactive.neutral.bg.pressed',
        },
      },
    },
    {
      interactive: true,
      disabled: false,
      tone: 'soft',
      css: {
        backgroundColor: {
          base: 'Card.Root.interactive.soft.bg.default',
          _hover: 'Card.Root.interactive.soft.bg.hover',
          _active: 'Card.Root.interactive.soft.bg.pressed',
        },
      },
    },
    {
      interactive: true,
      outlined: true,
      disabled: false,
      tone: 'neutral',
      css: {
        borderColor: {
          base: 'Card.Root.interactive.neutral.border.default',
          _hover: 'Card.Root.interactive.neutral.border.hover',
          _active: 'Card.Root.interactive.neutral.border.pressed',
        },
      },
    },
    {
      interactive: true,
      outlined: true,
      disabled: false,
      tone: 'soft',
      css: {
        borderColor: {
          base: 'Card.Root.interactive.soft.border.default',
          _hover: 'Card.Root.interactive.soft.border.hover',
          _active: 'Card.Root.interactive.soft.border.pressed',
        },
      },
    },
    {
      elevated: true,
      interactive: true,
      disabled: false,
      css: {
        backgroundColor: {
          base: 'Card.Root.interactive.neutral.elevated.bg.default',
          _hover: 'Card.Root.interactive.neutral.elevated.bg.hover',
          _active: 'Card.Root.interactive.neutral.elevated.bg.pressed',
        },
        boxShadow: {
          base: 'Card.Root.interactive.default',
          _hover: 'Card.Root.interactive.hover',
          _active: 'Card.Root.interactive.pressed',
        },
      },
    },
    {
      elevated: true,
      interactive: true,
      disabled: false,
      tone: 'soft',
      css: {
        backgroundColor: {
          base: 'Card.Root.interactive.soft.elevated.bg.default',
          _hover: 'Card.Root.interactive.soft.elevated.bg.hover',
          _active: 'Card.Root.interactive.soft.elevated.bg.pressed',
        },
        borderColor: {
          base: 'Card.Root.interactive.soft.border.default',
          _hover: 'Card.Root.interactive.soft.border.hover',
          _active: 'Card.Root.interactive.soft.border.pressed',
        },
      },
    },
    {
      disabled: true,
      interactive: true,
      css: {
        boxShadow: 'none',
        cursor: 'default',
        opacity: 'disabled',
      },
    },
  ],
});
